// 城市地址
export const cityAdress= [
	{
	  id: 1,
	  name: "北京",
	  eng: "BEIJING",
	  n_icon: require("../../assets/images/home/北京-未选中@2x.png"),
	  s_icon: require("../../assets/images/home/北京@2x.png"),
	  address: "北京市朝阳区建国路89号华贸商务楼15号楼15层/16层",
	  tel: "010-85967767",
	  web: "www.pinuc.com",
	},
	 {
	  id: 2,
	  name: "上海",
	  eng: "SHANGHAI",
	  n_icon: require("../../assets/images/home/上海-未选中@2x.png"),
	  s_icon: require("../../assets/images/home/上海@2x.png"),
	  address: "上海市徐汇区徐虹中路20号西岸创意园2号楼6楼2533-2535",
	  tel: "021-60541503",
	  web: "www.pinuc.com",
	},
	 {
	  id: 3,
	  name: "广州",
	  eng: "GUANGZHOU",
	  n_icon: require("../../assets/images/home/广州-未选中@2x.png"),
	  s_icon: require("../../assets/images/home/广州@2x.png"),
	  address: "广州市天河区天河北路235号广州环贸中心4204B-01A",
	  tel: "020-88526160",
	  web: "www.pinuc.com",
	},
	{
	  id: 4,
	  name: "深圳",
	  eng: "SHENZHEN",
	  s_icon: require("@/assets/images/home/深圳@2x.png"),
	  n_icon: require("@/assets/images/home/深圳-未选中@2x.png"),
	  address:
		"深圳市福田区香蜜湖深南香蜜立交西南侧深铁置业大厦2907、2908",
	  tel: "400-007-6666",
	  web: "www.pinuc.com",
	},
	{
	  id: 5,
	  name: "成都",
	  eng: "CHENGDU",
	  s_icon: require("@/assets/images/home/成都@2x.png"),
	  n_icon: require("@/assets/images/home/成都-未选中@2x.png"),
	  address: "成都市锦江区东大街芷泉段68号时代8号3802",
	  tel: "400-007-6666",
	  web: "www.pinuc.com",
	},
	{
	  id: 6,
	  name: "武汉",
	  eng: "WUHAN",
	  s_icon: require("@/assets/images/home/武汉@2x.png"),
	  n_icon: require("@/assets/images/home/武汉-未选中@2x.png"),
	  address: "湖北省武汉市江汉区葛洲坝龙湖江宸天街A座31楼",
	  tel: "027-59353608",
	  web: "www.pinuc.com",
	},
	{
	  id: 12,
	  name: "长沙",
	  eng: "CHANGSHA",
	  s_icon: require("@/assets/images/home/长沙@2x.png"),
	  n_icon: require("@/assets/images/home/长沙-未选中@2x.png"),
	  address:
		"湖南省长沙市开福区中山路589号开福万达广场B区商业综合体（含写字楼）19009、19010室",
	  tel: "0731-82207626",
	  web: "www.pinuc.com",
	},
	{
	  id: 7,
	  name: "重庆",
	  eng: "CHONGQING",
	  s_icon: require("@/assets/images/home/重庆@2x.png"),
	  n_icon: require("@/assets/images/home/重庆-未选中@2x.png"),
	  address: "重庆市渝中区解放碑五一路99号二单元协信中心2705室",
	  tel: "023-63266916",
	  web: "www.pinuc.com",
	},
	{
	  id: 8,
	  name: "杭州",
	  eng: "HANGZHOU",
	  s_icon: require("@/assets/images/home/杭州@2x.png"),
	  n_icon: require("@/assets/images/home/杭州-未选中@2x.png"),
	  address: "浙江省杭州市西湖区翠苑街道学院路28-38号1幢1801-1室",
	  tel: "0571-85060625",
	  web: "www.pinuc.com",
	},
	{
	  id:9,
	  name: "南京",
	  eng: "NANJING",
	  s_icon: require("@/assets/images/home/南京@2x.png"),
	  n_icon: require("@/assets/images/home/南京-未选中@2x.png"),
	  address: "南京市秦淮区中山东路288号新世纪广场A幢4001",
	  tel: "025-66621599",
	  web: "www.pinuc.com",
	},
	{
	  id: 10,
	  name: "天津",
	  eng: "TIANJIN",
	  s_icon: require("@/assets/images/home/天津@2x.png"),
	  n_icon: require("@/assets/images/home/天津-未选中@2x.png"),
	  address: "天津市和平区南市大街与福安大街交口保利广场2808室",
	  tel: "022-27271906",
	  web: "www.pinuc.com",
	},
	{
	  id: 11,
	  name: "西安",
	  eng: "XIAN",
	  s_icon: require("@/assets/images/home/西安@2x.png"),
	  n_icon: require("@/assets/images/home/西安-未选中@2x.png"),
	  address: "西安市莲湖区北关正街50号静安广场2号楼1007室",
	  tel: "400-007-6666",
	  web: "www.pinuc.com",
	},
	{
	  id: 13,
	  name: "南昌",
	  eng: "NANCHANG",
	  s_icon: require("@/assets/images/home/南城@2x.png"),
	  n_icon: require("@/assets/images/home/南昌-未选中@2x.png"),
	  address: "江西省南昌市红谷滩新区万达中心B3写字楼-3602",
	  tel: "400-007-6666",
	  web: "www.pinuc.com",
	},
	{
	  id: 14,
	  name: "合肥",
	  eng: "HEFEI",
	  s_icon: require("@/assets/images/home/合肥@2x.png"),
	  n_icon: require("@/assets/images/home/合肥-未选中@2x.png"),
	  address: "安徽省合肥市蜀山区荷叶地街道新城国际D座905-1",
	  tel: "0551-62376539",
	  web: "www.pinuc.com",
	},
	{
	  id: 15,
	  name: "昆明",
	  eng: "KUNMING",
	  s_icon: require("@/assets/images/home/昆明@2x.png"),
	  n_icon: require("@/assets/images/home/昆明-未选中@2x.png"),
	  address: "云南省昆明市西山区环城南路777号昆钢大厦18楼C单元",
	  tel: "0871-65105508",
	  web: "www.pinuc.com",
	},
	// {
	//   id: 16,
	//   name: "苏州",
	//   eng: "SUZHOU",
	//   s_icon: require("@/assets/images/home/苏州-选中@2x.png"),
	//   n_icon: require("@/assets/images/home/苏州-未选中@2x.png"),
	//   address: "江苏省苏州市工业园区苏雅路388号新天翔广场A座1915",
	//   tel: "0512-62621819",
	//   web: "www.pinuc.com",
	// },
	{
	  id: 17,
	  name: "郑州",
	  eng: "ZHENGZHOU",
	  s_icon: require("@/assets/images/home/郑州@2x.png"),
	  n_icon: require("@/assets/images/home/郑州-未选中@2x.png"),
	  address: "河南省郑州市金水区金水路226号楷林国际B座13楼1309",
	  tel: "0371-63366927",
	  web: "www.pinuc.com",
	},
	// {
	//   id: 18,
	//   name: "宁波",
	//   eng: "NINGBO",
	//   s_icon: require("@/assets/images/home/宁波@2x.png"),
	//   n_icon: require("@/assets/images/home/宁波-未选中@2x.png"),
	//   address: "浙江省宁波市鄞州区和源路318号中银大厦2003",
	//   tel: "0574-88208516",
	//   web: "www.pinuc.com",
	// },
	{
	  id: 19,
	  name: "兰州",
	  eng: "LANZHOU",
	  s_icon: require("@/assets/images/home/兰州@2x.png"),
	  n_icon: require("@/assets/images/home/兰州-未选中@2x.png"),
	  address: "甘肃省兰州市城关区庆阳路326-328号兰州国际贸易中心1601室",
	  tel: "400-007-6666",
	  web: "www.pinuc.com",
	},
  ]


// WEBPACK FOOTER //
// ./src/pages/home/data.js